if(!customElements.get('modal-js')){
    class ModalJs extends HTMLElement {
        constructor() {
            super();

            this.modal = this.querySelector('.modal__wrapper');
            this.opener = this.querySelector('.modal__opener');
            this.closers = this.querySelectorAll('.modal__closer, .modal__overlay');
        }

        connectedCallback() {
            this.setOpener();
            this.setClosers();

        }

        setOpener(){
            this.opener.addEventListener('click', this.openModal.bind(this));
        }

        setClosers() {
            this.closers.forEach(closer => {
                closer.addEventListener('click', this.closeModal.bind(this));
            });
        }
                
        openModal(){
            this.modal.classList.add('modal--open');
        }

        closeModal() {
            this.modal.classList.remove('modal--open');
        }
    }

    customElements.define('modal-js', ModalJs);
}

class CartRecommendationsManager {
    constructor() {
        this.bindEvents();
    }

    bindEvents() {
        document.addEventListener('cart:change', (event) => {
            this.recommendationsContainer = document.getElementById('cart-recommendations');
            this.recommendedProducts = this.recommendationsContainer.querySelectorAll('.horizontal-product__info');

            if (event.detail?.cart?.items && this.recommendationsContainer) {
                this.updateRecommendations(event.detail.cart.items);
            }
        });
    }

    updateRecommendations(cartItems) {
        this.recommendedProducts.forEach(productWrapper => {
            const productId = productWrapper.dataset.productId;
            const variantsCount = parseInt(productWrapper.dataset.variantsCount);

            // On ne gère que les produits avec une seule variante
            if (variantsCount === 1) {
                const isInCart = cartItems.some(item => item.product_id.toString() === productId);
                if (isInCart) {
                    productWrapper.classList.add('hidden');
                } else {
                    productWrapper.classList.remove('hidden');
                }
            }
        });
    }
}

// Initialisation automatique du gestionnaire de recommandations
document.addEventListener('DOMContentLoaded', () => {
    new CartRecommendationsManager();
});

function reviewsSectionAnchor() {
    const targetSection = document.getElementById('sectionReviews') || document.getElementById('judgeme_product_reviews');
    targetSection.scrollIntoView({ behavior: 'smooth' });
}